export default "__VITE_ASSET__B1_3a_Uz__"